import React, { useState } from "react";
import "./ModalEditField.css";
import { useUpdateProfile } from "../../../hooks/useUpdateProfile";

const PhoneNumberModal = ({ initialValue, action, onSave, onClose }) => {
  const [countryCode, setCountryCode] = useState("+61");
  const [phoneNumber, setPhoneNumber] = useState(initialValue || "");
  const { updateProfileField } = useUpdateProfile();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fullNumber = `${countryCode} ${phoneNumber}`;
    const success = await updateProfileField("Mobile phone", fullNumber);
    if (success) {
      onSave(fullNumber);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Enter your mobile phone number</h3>
        <p style={{ marginTop: "-0.6rem", fontWeight: "400", color: "#333", fontSize: "0.95rem" }}>
          We will text you a one-time verification code to confirm your number
        </p>

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem", marginTop: "1rem" }}>
          <div style={{ display: "flex", gap: "0.7rem" }}>
            <select
              style={{
                padding: "0.7rem",
                fontSize: "1rem",
                borderRadius: "8px",
                border: "1px solid #ccc",
                background: "white",
                fontWeight: "500",
                minWidth: "95px"
              }}
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
            >
              <option value="+61">🇦🇺 +61</option>
              <option value="+57">🇨🇴 +57</option>
              <option value="+1">🇺🇸 +1</option>
            </select>

            <input
              type="tel"
              placeholder="Enter a mobile phone number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
              style={{
                flex: 1,
                padding: "0.7rem",
                border: "1px solid #ccc",
                borderRadius: "8px",
                fontSize: "1rem",
                fontWeight: "500"
              }}
            />
          </div>

          <div className="modal-buttons">
            <button type="button" onClick={onClose} className="cancel-btn">
              Cancel
            </button>
            <button type="submit" className="save-btn">
              {action}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PhoneNumberModal;
